import React from "react";
import { useTranslation } from "react-i18next";

function CardBody({ user = {} }) {
  const serviceRates = user?.serviceRates ?? [];
  const domains = user?.domains ?? [];
  const uniqueServices = Array.from(
    serviceRates
      .reduce((map, service) => {
        const key = service.serviceId + "|" + service.serviceTitle;
        if (!map.has(key)) {
          map.set(key, {
            serviceId: service.serviceId,
            serviceTitle: service.serviceTitle,
          });
        }
        return map;
      }, new Map())
      .values()
  );

  const [t] = useTranslation();
  return (
    <>
      <div className="flex pt-[20px] items-center gap-[16px] self-stretch border-t-[1px] border-solid border-default-color">
        <div className="grid gap-[12px] h-full w-full">
          <div className="text-[#A0A0AB] font-regular text-[14px]">
            {t("Services")}
          </div>
          {uniqueServices.map((service, i) => {
            return (
              <div
                key={`${i}`}
                className="text-black font-regular text-[18px]"
              >{`${i + 1}. ${service.serviceTitle}`}</div>
            );
          })}
        </div>

        <div className="grid gap-[12px] h-full w-full">
          <div className="text-[#A0A0AB] font-regular text-[14px]">
            {t("Languages")}
          </div>
          {uniqueServices.map((service, i) => {
            const serviceRatesPerId = serviceRates.filter(
              (el) => el.serviceId === service.serviceId
            );
            return (
              <div
                key={`${i}`}
                className="flex items-center gap-[10px] self-stretch flex-wrap"
              >
                {serviceRatesPerId.map((rate, i) => {
                  let isBorder = i > 0 && i < serviceRatesPerId.length;
                  let isFromLang = rate?.fromLanguageCode;
                  let isToLang = rate?.toLanguageCode;
                  let isNoneLang = !isFromLang && !isToLang;
                  return (
                    <div
                      key={`${i}`}
                      className={`flex gap-[6px] ${
                        isBorder && !isNoneLang
                          ? "border-l-[1px] border-solid border-default-color"
                          : ""
                      }`}
                    >
                      {isFromLang && (
                        <div
                          title={rate.fromLanguageCode.toUpperCase()}
                          className={`${
                            isBorder ? "ml-[10px]" : ""
                          } grid py-[6px] px-[6px] items-center gap-[10px] rounded-[4px] bg-[#DCF6E7] h-[31px]`}
                        >
                          <div className="font-medium text-[14px] text-base-black">
                            {rate.fromLanguageCode.toUpperCase()}
                          </div>
                        </div>
                      )}
                      {isToLang && (
                        <div
                          title={rate.toLanguageCode.toUpperCase()}
                          className={`${
                            isBorder && !isFromLang ? "ml-[10px]" : ""
                          } grid py-[6px] px-[6px] items-center gap-[10px] rounded-[4px] bg-[#FCE7E7] h-[31px]`}
                        >
                          <div className="font-medium text-[14px] text-base-black">
                            {rate.toLanguageCode.toUpperCase()}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex pt-[20px] items-center gap-[16px] self-stretch border-t-[1px] border-solid border-default-color">
        <div className="grid gap-[12px] h-full w-full">
          <div className="text-[#A0A0AB] font-regular text-[14px]">
            {t("Domains")}
          </div>
          {domains.map((domain, i) => {
            return (
              <div className="text-black font-regular text-[18px]">{`${
                i + 1
              }. ${domain.title}`}</div>
            );
          })}
        </div>

        <div className="grid gap-[12px] h-full w-full">
          <div className="text-[#A0A0AB] font-regular text-[14px]"></div>
          {domains.map((domain, i) => {
            let subDomains = domain?.subDomains ?? [];
            return (
              <div
                key={`${i}`}
                className="flex items-center gap-[10px] self-stretch flex-wrap"
              >
                {subDomains.map((subDomain, i) => {
                  return (
                    <div
                      className={`flex items-center gap-[10px] self-stretch flex-wrap`}
                      key={`${i}`}
                    >
                      <div className="bg-light-primary p-[6px] items-center flex justify-center gap-[2px] rounded-[4px]">
                        <div className="text-primary font-medium text-[14px]">
                          {subDomain?.title}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default CardBody;
